import { render, staticRenderFns } from "./companyManagement.vue?vue&type=template&id=633b4a02&scoped=true"
import script from "./companyManagement.vue?vue&type=script&lang=js"
export * from "./companyManagement.vue?vue&type=script&lang=js"
import style0 from "./companyManagement.vue?vue&type=style&index=0&id=633b4a02&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b4a02",
  null
  
)

export default component.exports